import React, { forwardRef, useCallback } from 'react'

import { useComponentConfig } from '../../hooks/useComponentConfig'
import { Loading } from '../Loading'
import { StyledButton } from './styles'
import type { ButtonProps } from './types'

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
    (
        {
            type = 'default',
            className,
            style,
            size = 'md',
            icon,
            primaryColor,
            danger,
            ghost,
            loading,
            disabled: _disabled,
            block,
            children,
            htmlType = 'button',
            radius,
            suffix,
            highlighting,
            onClick,
            ...restProps
        },
        ref
    ) => {
        const { disabled } = useComponentConfig('button', { disabled: _disabled })
        const buttonIcon = (loading && <Loading outlined size={14} />) || icon
        const buttonDisabled = disabled || loading

        const existsIcon = !!buttonIcon
        const onlyIcon = existsIcon && !children

        const handleClick = useCallback(
            (e: React.MouseEvent<HTMLButtonElement>) => {
                if (disabled) {
                    return
                }
                onClick?.(e)
            },
            [disabled, onClick]
        )

        return (
            <StyledButton
                {...restProps}
                style={style}
                className={className}
                ref={ref}
                buttonType={type}
                type={htmlType}
                size={size}
                block={block}
                danger={danger}
                ghost={ghost}
                highlighting={highlighting}
                disabled={buttonDisabled}
                icon={onlyIcon}
                onClick={handleClick}
                css={{
                    borderRadius: radius,
                    // 当传入 primaryColor 时，覆盖默认的颜色
                    ...(primaryColor && {
                        // primary 按钮的主色
                        ...(type === 'primary' &&
                            !danger &&
                            !ghost && {
                                backgroundColor: primaryColor,
                                '@media (any-hover: hover)': {
                                    '&:not(:disabled):hover': {
                                        backgroundColor: `color-mix(in srgb, ${primaryColor} 85%, black)`
                                    }
                                }
                            }),
                        // primary ghost 按钮
                        ...(type === 'primary' &&
                            ghost &&
                            !danger && {
                                color: primaryColor,
                                borderColor: primaryColor,
                                backgroundColor: 'transparent'
                            })
                        // // danger 按钮（primary）
                        // ...(danger && type === 'primary' && !ghost && {
                        //     backgroundColor: primaryColor,
                        //     borderColor: primaryColor,
                        //     '@media (any-hover: hover)': {
                        //         '&:not(:disabled):hover': {
                        //             backgroundColor: `color-mix(in srgb, ${primaryColor} 85%, black)`,
                        //             borderColor: `color-mix(in srgb, ${primaryColor} 85%, black)`
                        //         }
                        //     }
                        // }),
                        // // danger 按钮（default/ghost）
                        // ...(danger && (type === 'default' || ghost) && {
                        //     color: primaryColor,
                        //     borderColor: primaryColor,
                        //     backgroundColor: 'transparent',
                        //     '@media (any-hover: hover)': {
                        //         '&:not(:disabled):hover': {
                        //             borderColor: `color-mix(in srgb, ${primaryColor} 85%, black)`
                        //         }
                        //     }
                        // })
                    })
                }}
            >
                {buttonIcon}
                {children}
                {suffix}
            </StyledButton>
        )
    }
)
